<template>
  <div class="all">
    <div v-html="content">

    </div>
    <div class="advert">
      <a :href="advert_data.target_url">
        <img :src="advert_data.pic" alt="" class="advert_img">
      </a>
    </div>
  </div>
</template>

<script>
    export default {
        name: "ContentWithBottomAdvert",
      data() {
          return{
            token: this.$route.query.token,
            advert_data: '',
            content: '',
            module: this.$route.query.module,
            uuid: this.$route.query.uuid,
            advert_space: this.$route.query.advert_space,
          }
      },
      mounted() {
          console.log(apiUrl);
          this.$ajax.get(apiUrl + 'api/app/v1/base/content_page?module=' + this.module + '&uuid=' + this.uuid + '&token=' + this.token)
            .then((res) => {
              this.content = res.data.data;
            });
          this.$ajax.get(apiUrl + 'api/app/v1/advert/base/get_single_advert?token=' + this.token + '&advert_space=' + this.advert_space)
            .then((res) => {
              this.advert_data = res.data.data.advert;
            })
      }
    }
</script>

<style scoped>
  .all{
    width: 100%;
    height: auto;
  }
  .advert_img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/ContentWithBottomAdvert.vue